import {
	createABUrl,
	splitABUrl,
	splitABUrlFilter,
	splitABUrlEdit,
	oldLogsSplitABUrl,
	oldLogsSplitABUrlFilter
} from '@/api/Erp'

export default {
	async createAB (payload, token) {
		try {
			const response = await createABUrl.post(
				payload,
				{
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})
			return response.data
		} catch (error) {
      return error.response
    }
	},
	async getSplitAb (page, size, token) {
		try {
			const response = await splitABUrl.get({
				uriParams: {
					page,
					size,
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response.data
		} catch (error) {
			return error.response
		}
	},
	async getSplitAbFilter (page, size, filter, token) {
		try {
			const response = await splitABUrlFilter.get({
				uriParams: {
					page,
					size,
					filter,
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response.data
		} catch (error) {
			return error.response
		}
	},
	async putUrlEdition (payload, token) {
		const name = payload.test_name
		try {
			const response = await splitABUrlEdit.put(
				payload,
				{
					uriParams: {
						test_name: name
					},
					headers: {
						'Authorization': `Bearer ${token}`
					}
				},
			)
			return response.data
		} catch (error) {
			return error.response
		}
	},
	async getOldLogsSplitAb (page, size, token) {
		try {
			const response = await oldLogsSplitABUrl.get({
				uriParams: {
					page,
					size,
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response.data
		} catch (error) {
			return error.response
		}
	},
	async getOldLogsSplitAbFilter (page, size, filter, token) {
		try {
			const response = await oldLogsSplitABUrlFilter.get({
				uriParams: {
					page,
					size,
					filter,
				},
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response.data
		} catch (error) {
			return error.response
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/modules/splitTest/resources.js